var bsn = require('bootstrap.native');
// var customSelect = require("custom-select").default;
global.jQuery = require('jquery');
var elevatezoom = require("@zeitiger/elevatezoom");
var Stickyfill = require("stickyfilljs");
import 'jquery-match-height';
// F:\project-files\lfn-new\lfn-new\node_modules\bootstrap.native\dist ok

let matchParagraphHeight = jQuery('.onze__product-content p')
let matchProductCardHeight = jQuery('.onze__product-content')
let matchContactTextHeight = jQuery('.contact__text-box')

jQuery(window).on('load resize',function(){
    if(matchParagraphHeight) { matchParagraphHeight.matchHeight({byRow: true}); }
    if(matchProductCardHeight) { matchProductCardHeight.matchHeight({byRow: true}); }
    if(matchContactTextHeight) { matchContactTextHeight.matchHeight({byRow: true}); }
});


function menuToggle() {
    var element = document.getElementsByClassName('menu__btn')[0];
    element.classList.toggle("menu__btn__active");
    var menu = document.getElementsByClassName('menu__section--main')[0];
    menu.classList.toggle("menu__btn__active");
}
function langToogle(params) {
    var menu = document.getElementsByClassName('lang__nav')[0];
    menu.classList.toggle("sub__active");
}
 
window.onload = function(e){  
    // customSelect('select');
    document.getElementsByClassName('menu__btn')[0].onclick  = function(e) {
        menuToggle();
    };
    if (typeof(document.getElementsByClassName('lang__active')[0]) != 'undefined' && document.getElementsByClassName('lang__active')[0] != null){
        document.getElementsByClassName('lang__active')[0].onclick  = function(e) {
            langToogle();
        };
        document.getElementsByClassName('lang__nav')[0].onclick  = function(e) {
            langToogle();
        };
    }
};
(function($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */
  
    $.fn.visible = function(partial) {
      
        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
      
      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  
    };
      
  })(jQuery);
jQuery(document).ready(function () {
    jQuery('#thumb').elevateZoom({
        zoomType: "lens",
        lensShape: "round",
        lensSize: 180,
        borderSize: 2,
        borderColour: '#c5a761',
    });
    var elements = jQuery('.choco-box');
    Stickyfill.add(elements);
    jQuery('.home__products--content>*:not(.no-animate)').each(function(){
        jQuery(this).addClass('ae-'+(jQuery(this).index()+1)+' rightIn');
    });
});
jQuery(window).on('load scroll',function(){
    var allMods = jQuery('[class*="ae-"]');
    allMods.each(function(i, el) {
      var el = jQuery(el);
      if (el.visible(true)) {
        el.addClass('imIn'); 
      }
    });
});

window.scrollToId = function(id, speed) {
    jQuery('html, body').animate({ scrollTop: jQuery('#' + id).offset().top }, speed)
}


// WEBPACK FOOTER //
// ./resources/js/app.js